export default {
    namespaced: true,
    state: {
        tipoDiIntervento: -1
    },
    mutations: {
        SET_TIPO_DI_INTERVENTO: (state: any, payload: number) => {
            state.idRilevamento = payload
        }
    },
    actions: {
        resettaFiltri({commit}: any) {
            commit('SET_TIPO_DI_INTERVENTO', -1)
        }
    }
}
